import { render, staticRenderFns } from "./libro.vue?vue&type=template&id=537e1bd9"
import script from "./libro.vue?vue&type=script&lang=js"
export * from "./libro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports